export default {"src":"/_next/static/media/arrow-down-bordered.bca8ffe6.svg","height":22,"width":22};